import React from 'react';
import { Box } from '@mui/material';

export const SocialShareAtag = (props) => (
  <Box
    sx={{
      display: 'inline-block',
      backgroundColor: props.backgroundColor,
      position: 'relative',
      margin: '0 0 .5em 0',
      padding: '5px',
      color: '#fff',
      fontFamily: '"Helvetica Neue", "Helvetica", sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1em',
      textDecoration: 'none',
      border: 0,
      borderRadius: '0.3em',
      '-webkit-border-radius': '0.3em',
      '-moz-border-radius': '0.3em',
      '-ms-border-radius': '0.3em',
      '-o-border-radius': '0.3em',
      cursor: 'pointer',
      '& svg path': {
        fill: 'white',
      },
    }}
    component="a"
    data-testid="social-share-link"
    {...props}
  />
);

export default SocialShareAtag;
